/* ============================================================================
   product-card.js — Verhalten der Produktkachel (Varianten-Swatches)
   ----------------------------------------------------------------------------
   Ersetzt `productVariantsColors()` aus assets/app.js:455-473.

   Die Kachel steckt in snippets/rb-collection-item.liquid. Bis M5 lud dieses
   Skript (als nko-product-card.js) global im <head>; jetzt bringt es jede
   Section mit, die Kacheln mit Swatches rendert (R5): main-collection
   (Normalzweig), rb-catalog-tabs, main-search, rb-related-products,
   page-family-template und main-article (nur mit verwandten Produkten).
   Ein Modul laeuft je Adresse genau einmal, mehrere Tags auf einer Seite
   binden den Hoerer also nicht doppelt.

   WAS DAS LEGACY TAT
   ---------------------------------------------------------------------------
       mainImg.hide();
       secondImg.removeClass("lazyloaded").removeAttr("style")
                .addClass("lazyload").show();
       secondImg.attr("data-bg", newImg);

   Also: Hauptbild verstecken, ein leeres <div> einblenden und lazysizes das
   neue Bild als HINTERGRUND nachladen lassen. Ein Umweg mit drei beteiligten
   Elementen, einer Bibliothek und vier Klassenwechseln — um ein Bild zu
   tauschen.

   Hier werden stattdessen `src` und `srcset` des Hauptbildes gesetzt. Das
   `<div class="item__imageSrcSecond">` ist damit ueberfluessig und aus dem
   Markup entfernt.

   GEWOEHNLICHE DELEGATION, KEINE SPERRE
   ---------------------------------------------------------------------------
   Bis hierher lief der Hoerer in der Capture-Phase und rief
   `stopPropagation()`: app.js band seine jQuery-Handler direkt an jedes
   `.thumb__img`, und die haetten das getauschte Hauptbild wieder versteckt.
   app.js ist geloescht; die Sperre verschluckte seitdem nur noch den Klick
   fuer jeden anderen Hoerer (Apps, Analytics). Jetzt ein normaler Hoerer am
   Dokument in der Bubble-Phase — er erreicht auch die Kacheln, die "Mehr
   laden" und die Filter nachtraeglich einsetzen. Kein `preventDefault()`:
   die Swatches sind <button type="button"> ausserhalb des Produktlinks, es
   gibt keine Standardaktion.
   ==========================================================================  */

const THUMB = ".thumbs .thumb__img";
const MEHR = ".thumbs .thumb__item--more";

function tauscheBild(thumb) {
  const kachel = thumb.closest(".item");
  if (!kachel) return;

  const haupt = kachel.querySelector(".item__imageSrc");
  const neu = thumb.dataset.variantImg;
  if (!haupt || !neu) return;

  /* Dieselben Groessenstufen wie das Ausgangsbild, nur fuer die Variante.
     `sizes` bleibt am Bild stehen, die Kachel behaelt so exakt ihre Groesse.
     Vorher wurde `srcset` entfernt und ein festes 400px-Bild gesetzt — auf
     2x-Displays sichtbar weicher als vor dem Klick. `srcset` zuerst, sonst
     laedt der Browser kurz das `src` allein. */
  if (thumb.dataset.variantSrcset) haupt.srcset = thumb.dataset.variantSrcset;
  else haupt.removeAttribute("srcset");
  haupt.src = neu;

  /* Das Hover-Bild bleibt stehen: beim Ueberfahren erscheint wie auf LIVE
     das zweite Produktbild. Bis hierher wurde es per `hidden` versteckt —
     die Hover-Regel blendete das Hauptbild trotzdem aus, und die Kachel war
     leer.

     Den gewaehlten Swatch bekommt nur der Screenreader mitgeteilt. Sichtbar
     markiert wird er nicht, LIVE tut das auch nicht. */
  for (const t of kachel.querySelectorAll(THUMB)) {
    t.setAttribute("aria-pressed", t === thumb ? "true" : "false");
  }
}

document.addEventListener("click", (e) => {
  const thumb = e.target.closest?.(THUMB);
  if (thumb) {
    tauscheBild(thumb);
    return;
  }

  // "+3"-Knopf: klappt die restlichen Farben aus. Verhalten aus app.js:470.
  const mehr = e.target.closest?.(MEHR);
  if (mehr) {
    const liste = mehr.parentElement;
    mehr.setAttribute("aria-expanded", "true");
    liste?.classList.add("is-open");
    /* `.is-open` blendet den Knopf aus. Ohne neues Ziel fiele der Fokus bei
       Tastaturbedienung auf <body> zurueck — also auf die erste der eben
       aufgeklappten Farben. */
    liste?.querySelector(".thumb__item--hide .thumb__img")?.focus();
  }
});

/* ----------------------------------------------------------------------------
   NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer`.

   Diese Datei wird ungebaut ausgeliefert. Frueher packte esbuild sie in eine
   IIFE; diesen eigenen Gueltigkeitsbereich gibt ihr jetzt der Modulbereich.
   Als klassisches Skript laegen alle Namen oben global und stiessen sich an
   denen der anderen Theme-Dateien (`FOKUSSIERBAR` steht in zwei, `starte` in
   mehreren), und `open` aus popup.js ueberschriebe `window.open`. Module
   laufen wie `defer` nach dem Parsen in Dokumentreihenfolge, aber nur einmal
   je URL und immer im strict mode.
   ---------------------------------------------------------------------------- */
